import type { ComponentType } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface EntityPageHeaderProps {
  title: string
  subtitle?: string
  icon?: ComponentType<{ className?: string }>
  backTo?: string
  createTo?: string
  createLabel?: string
}

export function EntityPageHeader({ title, subtitle, icon: Icon, backTo, createTo, createLabel }: EntityPageHeaderProps) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="flex items-center gap-3">
        {backTo && (
          <button
            onClick={() => navigate(backTo)}
            className="rounded-lg p-2 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-700"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
        )}
        {Icon && !backTo && (
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary to-primary/70 text-white shadow-md">
            <Icon className="h-6 w-6" />
          </div>
        )}
        <div>
          <h1 className="text-2xl font-bold text-neutral-900">{title}</h1>
          {subtitle && (
            <p className="mt-0.5 text-sm text-neutral-500">{subtitle}</p>
          )}
        </div>
      </div>
      {createTo && (
        <button
          onClick={() => navigate(createTo)}
          className="flex items-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary/90"
        >
          <Plus className="h-4 w-4" />
          {createLabel || t('common.create', 'Créer')}
        </button>
      )}
    </div>
  )
}
